// Web replacement for react-native-country-codes-picker.
// A minimal searchable country/dial-code picker covering common countries —
// swap COUNTRIES for a fuller list if you need broader coverage.
import React, { useMemo, useState } from 'react';
import { Modal, View, Text, TextInput, Pressable, ScrollView } from 'react-native-web';

const COUNTRIES = [
  { name: 'United States', code: 'US', dial_code: '+1' },
  { name: 'Canada', code: 'CA', dial_code: '+1' },
  { name: 'United Kingdom', code: 'GB', dial_code: '+44' },
  { name: 'Australia', code: 'AU', dial_code: '+61' },
  { name: 'India', code: 'IN', dial_code: '+91' },
  { name: 'Mexico', code: 'MX', dial_code: '+52' },
  { name: 'Germany', code: 'DE', dial_code: '+49' },
  { name: 'France', code: 'FR', dial_code: '+33' },
  { name: 'Spain', code: 'ES', dial_code: '+34' },
  { name: 'Italy', code: 'IT', dial_code: '+39' },
  { name: 'Brazil', code: 'BR', dial_code: '+55' },
  { name: 'China', code: 'CN', dial_code: '+86' },
  { name: 'Japan', code: 'JP', dial_code: '+81' },
  { name: 'South Korea', code: 'KR', dial_code: '+82' },
  { name: 'Nigeria', code: 'NG', dial_code: '+234' },
  { name: 'Kenya', code: 'KE', dial_code: '+254' },
  { name: 'South Africa', code: 'ZA', dial_code: '+27' },
  { name: 'Philippines', code: 'PH', dial_code: '+63' },
  { name: 'Vietnam', code: 'VN', dial_code: '+84' },
  { name: 'Pakistan', code: 'PK', dial_code: '+92' },
];

const styles = {
  backdrop: { flex: 1, backgroundColor: 'rgba(15, 23, 20, 0.45)', justifyContent: 'center', alignItems: 'center' },
  sheet: { width: 320, maxHeight: 380, backgroundColor: '#fff', borderRadius: 14, padding: 14 },
  input: { borderWidth: 1, borderColor: '#D1D5DB', borderRadius: 8, paddingHorizontal: 10, paddingVertical: 8, marginBottom: 10 },
  row: { paddingVertical: 11, paddingHorizontal: 4, borderBottomWidth: 1, borderBottomColor: '#EEF1EF' },
  rowText: { fontSize: 15, color: '#14201C' },
  empty: { padding: 16, color: '#6B7A72', textAlign: 'center' },
};

export function CountryPicker({ show, onBackdropPress, inputPlaceholder, searchMessage, pickerButtonOnPress, style }) {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return COUNTRIES;
    return COUNTRIES.filter(
      (c) => c.name.toLowerCase().includes(q) || c.dial_code.includes(q) || c.code.toLowerCase().includes(q)
    );
  }, [query]);

  if (!show) return null;

  return React.createElement(
    Modal,
    { transparent: true, animationType: 'fade', visible: show, onRequestClose: onBackdropPress },
    React.createElement(
      Pressable,
      { style: styles.backdrop, onPress: onBackdropPress },
      React.createElement(
        Pressable,
        { style: [styles.sheet, style && style.modal], onPress: (e) => e.stopPropagation && e.stopPropagation() },
        React.createElement(TextInput, {
          value: query,
          onChangeText: setQuery,
          placeholder: inputPlaceholder || 'Search country...',
          style: styles.input,
        }),
        React.createElement(
          ScrollView,
          { style: { flex: 1 } },
          filtered.length === 0
            ? React.createElement(Text, { style: styles.empty }, searchMessage || 'No results')
            : filtered.map((item) =>
                React.createElement(
                  Pressable,
                  { key: item.code, onPress: () => pickerButtonOnPress(item), style: styles.row },
                  React.createElement(Text, { style: styles.rowText }, item.name + '   ' + item.dial_code)
                )
              )
        )
      )
    )
  );
}
